import { Model, View } from '@lernetz/ts-lib';
import { context } from '@lernetz/ts-lib/src/view/Template';

import template from './Audio.html';

interface Asset {
    file_name: string;
}

export class Audio extends Model {

    public readonly alt?: string;
    public readonly file?: Asset;
    public readonly description?: string;
    public readonly marginTop: string;
    public readonly marginBottom: string;

    public constructor(dto) {
        super({ marginTop: '', marginBottom: '', ...dto });
    }
}

export class AudioView extends View<Audio> {

    public constructor() {
        super({ template });
    }

    public init() {
        const hasAudio = !!this.data.file;
        if (hasAudio) {
            const audioNode = <HTMLAudioElement> this.node.querySelector('[js="audio"]');
            audioNode.src = context.downloadPath(this.data.file.file_name);

            const hasDescription = this.data.description && this.data.description !== '<p></p>';
            if (hasDescription) {
                this.node.querySelector('[js="description"]').innerHTML = this.data.description;
                this.node.querySelector('.caption').classList.remove('-hidden');
            }
        }
    }
}
